module.exports = __webpack_public_path__ + "static/media/CustomerInactiveIcon.a0492e3c.svg";